import { render, staticRenderFns } from "./ActosFinalizados.vue?vue&type=template&id=65c2e5db&scoped=true"
import script from "./ActosFinalizados.vue?vue&type=script&lang=js"
export * from "./ActosFinalizados.vue?vue&type=script&lang=js"
import style0 from "./ActosFinalizados.vue?vue&type=style&index=0&id=65c2e5db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2e5db",
  null
  
)

export default component.exports